// src/components/ChangePasswordModal.jsx
import React from "react";

export default function ChangePasswordModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "grid",
        placeItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{ background: "#fff", padding: 20, borderRadius: 10, minWidth: 320 }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ margin: 0, marginBottom: 8 }}>Change Password</h3>
        <p style={{ marginTop: 0 }}>
          Placeholder modal (Firebase removed). We’ll hook this to backend
          <code> /auth/change-password</code> later.
        </p>
        <button onClick={onClose} style={{ padding: "8px 12px" }}>Close</button>
      </div>
    </div>
  );
}
